import React, { lazy } from 'react';
import { Building, Home, Video } from 'lucide-react';
export default function AssessmentSection() {
  return <section className="py-16 bg-gray-50" data-id="element-194">
      <div className="container mx-auto px-4" data-id="element-195">
        <h2 className="text-3xl font-serif font-bold text-primary text-center mb-12" data-id="element-196">
          Additional Services – Prison, Home, and Remote Visits
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-197">
          {/* Prison Visits */}
          <div className="bg-white p-6 rounded-lg shadow-md h-full" data-id="element-198">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/18Vk7CVsLWHZnanuJYjKdC/Prison_Visits.png" alt="Prison psychiatric assessments by expert witness psychiatrist UK" className="w-full h-48 object-cover rounded-lg mb-4" loading="lazy" data-id="element-199" />
            <div className="text-primary mb-4 flex justify-center" data-id="element-200">
              <Building className="h-12 w-12" data-id="element-201" />
            </div>
            <h3 className="text-xl font-serif font-bold text-primary mb-2 text-center" data-id="element-202">
              Prison Visits
            </h3>
            <p className="text-slate text-center" data-id="element-203">
              In-person psychiatric assessments in secure settings. Dr Syed is
              available to conduct thorough evaluations within secure settings,
              ensuring timely assessments for legal proceedings.
            </p>
          </div>
          {/* Home Visits */}
          <div className="bg-white p-6 rounded-lg shadow-md h-full" data-id="element-204">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aQvbneRZRTrCPWszwKn2ay/Home_Visits.png" alt="Home psychiatric evaluations for medico-legal reports UK" className="w-full h-48 object-cover rounded-lg mb-4" loading="lazy" data-id="element-205" />
            <div className="text-primary mb-4 flex justify-center" data-id="element-206">
              <Home className="h-12 w-12" data-id="element-207" />
            </div>
            <h3 className="text-xl font-serif font-bold text-primary mb-2 text-center" data-id="element-208">
              Home Visits
            </h3>
            <p className="text-slate text-center" data-id="element-209">
              Compassionate assessments at home for comfort and convenience. Our
              priority is to ensure comfort and well-being, providing
              professional consultation in a familiar environment.
            </p>
          </div>
          {/* Remote Consultations */}
          <div className="bg-white p-6 rounded-lg shadow-md h-full" data-id="element-210">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rxyeXp7cZycaAAYrkvfcT9/Remote_Consultations.png" alt="Remote psychiatric expert witness consultations UK-wide" className="w-full h-48 object-cover rounded-lg mb-4" loading="lazy" data-id="element-211" />
            <div className="text-primary mb-4 flex justify-center" data-id="element-212">
              <Video className="h-12 w-12" data-id="element-213" />
            </div>
            <h3 className="text-xl font-serif font-bold text-primary mb-2 text-center" data-id="element-214">
              Remote Consultations
            </h3>
            <p className="text-slate text-center" data-id="element-215">
              Nationwide video assessments via Zoom/Teams. In addition to
              in-person clinics across the UK, we offer remote consultations for
              clients who prefer this option.
            </p>
          </div>
        </div>
      </div>
    </section>;
}